import { SelectInput, AutocompleteInput, required } from 'react-admin';
import React from 'react';

interface ChoiceItem {
  productId: string | number;
  name: string;
  [key: string]: any;
}

interface ItemSelectInputProps {
  sx?: object;
  source?: string;
  label?: string;
  showSearch?: boolean;
  choices?: ChoiceItem[];
  value?: any;
  onChange?: (value: any) => void; // 添加 onChange 属性
}

const ItemSelectInput: React.FC<ItemSelectInputProps> = ({
  showSearch = true,
  sx,
  source = 'productId',
  label = 'Product',
  choices = [],
  value,
  onChange, // 接收 onChange 回调
}) => {
  const formattedChoices = choices.map(item => ({
    id: item.productId,
    name: `${item.productId} - ${item.name}`,
    raw: item,
  }));

  const currentValue =
    value;

  const commonProps = {
    source,
    label,
    choices: formattedChoices,
    optionValue: 'id',
    optionText: 'name',
    validate: [required()],
    value: currentValue,
    isOptionEqualToValue: (option: any, val: any) =>
      String(option.id) === String(val?.productId ?? val?.id ?? val),
    parse: (value: any) => {
      if (!value) return undefined;
      // 如果已经是对象，直接返回
      if (typeof value === 'object') return value;
      // 如果是 id，找到对应完整对象返回
      const found = formattedChoices.find(c => c.id === value);
      return found?.raw ?? value;
    },
    format: (value: any) => {
      if (!value) return '';
      // value 是对象，显示 id 或 name
      if (typeof value === 'object') return value.productId ?? value.id ?? '';
      return value;
    },
    sx: {
      width: '100%',
      marginTop: 1,
      fontSize: 14,
      ...sx,
    },
    onChange: (value: any) => {
      if (onChange) {
        // 找到完整对象并返回
        const selectedChoice = formattedChoices.find(c => c.id === value);
        onChange(selectedChoice?.raw ?? value); // 返回原始对象或值
      }
    },
  };

  if (showSearch) {
    return (
      <AutocompleteInput
        {...commonProps}
        filterToQuery={(searchText: string) => ({ q: searchText })}

      />
    );
  }

  return <SelectInput {...commonProps} />;
};

export default ItemSelectInput;
